import React, { useEffect, useState } from "react";
import { Row, Col, Select, Input, TextArea, Attachment, Checkbox, Button, Slider, DragDrop, Toast, MultiSelectCheckBox } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { docUpload } from "../../../../../../store/actions/smsSenderId.action";
import { isEmpty } from "lodash";
import Styles from './index.module.scss';
import UploadedDocuments from "../uploadedDocuments";
import { UploadDocumentResponseType } from "../senderIdApplyForm";
import { validateOnlyNumbers } from "../../../../../../utils";

export type SenderIdPropType = {
    data: any;
    params: any,
    info: any,
    userProfile: any
}

export type DispatchPropsType = {
    onLoad: () => void;
    onClose: () => void;
    onSave: (id: any, formData: any, successCallback: (res: any, flag: boolean) => void) => void;
    uploadDocument: (document: any) => void;
    onLoadRoutes: (cb: (data: any, flag: boolean) => void) => void;
};

type IRoutesOption = {
    label: string,
    value: string
}

const SenderIdEditForm: React.FC<SenderIdPropType & DispatchPropsType> = ({
    onClose, onSave, data, onLoad, info, userProfile, onLoadRoutes,
    params
}) => {
    const [applyForSenderIdStatus, setApplyForSenderIdStatus] = useState(false);
    const [uploadedFile, setUploadedFile] = useState<any>([]);
    const [country, setCountry] = useState<string>('');
    const [senderIdName, setSenderIdName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [entityId, setEntityId] = useState<string>('');
    const [showUploadDocumentList, setShowUploadDocumentList] = useState<boolean>(false);
    const [selectedvSMSRoutes, setSelectedvSMSRoutes] = useState<string[]>([]);
    const [vSMSRoutes, setvSMSRoutes] = useState<Record<string, string>>({});
    const { country_id } = userProfile.fullProfile;

    const isIndianUser = country_id === 277;

    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        let dataById = data?.data?.senders[0];
        setSenderIdName(dataById.sender);
        setDescription(dataById.description);
        setCountry(dataById.country_details.iso_code);
        setEntityId(dataById.entity_id || info.senderIdData.default_entity_id);
        setApplyForSenderIdStatus(dataById.vsms_status === "0" ? false : true);
        let uploadedDocById: any[] = [];
        data?.data?.doc_details.forEach((item: any) => {
            uploadedDocById.push(item);
        });
        setUploadedFile(uploadedDocById);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        onLoadRoutes(routesCallback)
    }, []);

    const formatCountryList = () => {
        let countriesList: any = [];
        const countries = { ...info.senderIdData.countries };
        if (!isEmpty(countries)) {
            Object.entries(countries).forEach(([key, value]) => {
                countriesList.push({
                    key: key,
                    value: value
                })
            })
        }
        return countriesList.reverse();
    };

    const onError = () => {
        Toast(t('uploadFail'), 'error');
    }

    const handleUpload = (file: any, isValid: boolean) => {
        if (isValid) {
            const formData = new FormData();
            formData.append('document_ids', file[0]);
            dispatch(
                docUpload(formData, (res: any) => {
                    let uploads = [...uploadedFile, res.data];
                    setUploadedFile(uploads);
                    Toast(res.message, 'success');
                }, onError)
            );
        }
        else {
            Toast(t('BLD00602'), 'error');
        }
    };

    const getUploadedDocIds = (): string[] => {
        let doc_ids: string[] = [];
        uploadedFile.forEach((file: any) => {
            const selId = (data?.data?.doc_details).find((item: any) =>
                (item.id).toString() === (file.id).toString())
            if (selId === undefined) {
                doc_ids.push((file.id).toString());
            }
        });
        return doc_ids;
    }

    const callback = (res: any, flag: boolean): void => {
        if (flag && res.data && isEmpty(res.error)) {
            Toast(res.message, 'success')
            onClose();
            onLoad();
        } else if (!isEmpty(res.error)) {
            Object.keys(res.error).forEach((key: any) => {
                Toast(res.error[key], 'error');
            });
        } else {
            Toast(res.message, 'error');
        }
    }

    const handleFormSave = () => {
        // if (uploadedFile.length === 0) {
        //     Toast("Atleast one valid Document is required!", "error");
        //     return;
        // }
        if (entityIdErrorType() === "error") {
            Toast("Numeric Entity ID is allowed and it can only contain a minimum of 12 digits and maximum of 30 digits.", "error");
            return;
        }

        let saveDataOb: any = {
            activity_log_action: "Edited",
            activity_log_object: "SENDER ID",
            activity_log_object_value: senderIdName,
            doc_ids: uploadedFile.length > 0 ? getUploadedDocIds() : undefined,
            entity_id: entityId !== '' ? entityId : undefined
        }

        if (!isEmpty(info.senderIdData) && (info.senderIdData?.is_vsms_enabled).toString() === "1") {
            saveDataOb = {
                ...saveDataOb,
                sub_vsms: applyForSenderIdStatus,
                vsms_enabled_routes: applyForSenderIdStatus ? Object.values(selectedvSMSRoutes) : undefined
            }
        }
        onSave(params.id, saveDataOb, callback);
    }

    const getSelectedCountry = () => {
        let selCountry: string = country;
        if (country === "all") {
            selCountry = "others"
        }
        return info.senderIdData.countries[selCountry];
    }

    const entityIdErrorType = (): 'default' | 'error' => {
        return (isEmpty(entityId) || (entityId.length >= 12 && entityId.length <= 30 && validateOnlyNumbers(entityId))) ? 'default' : "error"
    }

    const getRoutesList = (): IRoutesOption[] => {
        let routes: IRoutesOption[] = [];
        Object.keys(vSMSRoutes).forEach((routeItem: string) => {
            routes.push({
                label: vSMSRoutes[routeItem],
                value: routeItem
            })
        })
        return routes;
    }

    const routesCallback = (data: any, flag: boolean) => {
        if (flag) {
            setvSMSRoutes(data.data);
        } else {
            Toast(t('BLD01637'), 'error');
        }
    }

    const getBody = () => {
        return <form>
            <div>
                <Row>
                    <Col size={12}>
                        <Select showBottomLabelSpace={false} className={Styles.inputField} options={formatCountryList()} label={t('mainCountry')} disabled placeholder={t('mainCountry')} value={getSelectedCountry()} onChange={(val: any, key: any) => setCountry(key.key)} showSearch></Select>
                    </Col>
                </Row>
                <Row>
                    <Col size={12} >
                        <Input showBottomLabelSpace={false} className={Styles.inputField} placeholder={t('KLR0032')} label={t('KLR0032')} disabled value={senderIdName} onChange={(event: any) => setSenderIdName(event.target.value)} />
                    </Col>
                </Row>
                <Row>
                    <Col size={12} >
                        <TextArea showBottomLabelSpace={false} className={Styles.inputField} label={t('BLD00607')} placeholder={t('BLD00607')} disabled value={description} onChange={(event: any) => setDescription(event.target.value)} />
                    </Col>
                </Row>
                {isIndianUser &&
                    <Row>
                        <Col size={12} style={{ marginBottom: '-1.5rem' }}>
                            <Input showBottomLabelSpace={false} className={Styles.inputField} placeholder={t('verifyEntityId')} label={t('verifyEntityId')} value={entityId} bottomLabelType={entityIdErrorType()} onChange={(event: any) => setEntityId(event.target.value)} />
                        </Col>
                    </Row>
                }
                <Row className={Styles.inputField}>
                    <Col size={12}>
                        <span className={Styles.attachLabel}>{t('KLR00117')}</span>
                        <div className={Styles.dragdropWrapper}>
                            <DragDrop
                                mini
                                onChange={(files: any, isValid: boolean) => { handleUpload(files, isValid) }}
                                fileFormats={'.jpg, .jpeg, .png, .pdf'}
                                placeholders={[t('KLR00141')]} />
                        </div>
                        <span className={Styles.uploadLink} onClick={() => setShowUploadDocumentList(true)}>{t('KLR00118')}</span>
                    </Col>
                </Row>
                {uploadedFile.length > 0 &&
                    <Row className={Styles.inputField}>
                        <Col size={12}>
                            <div className={Styles.inputField}>
                                {uploadedFile.map((file: any, index: number) => {
                                    return (
                                        <div className={Styles.attachmentWrapper}>
                                            <Attachment
                                                key={index}
                                                id={file.id}
                                                fileName={file.title}
                                                fileType={file.file_format || ''}
                                                fileUrl={file.url}
                                                download={true}
                                                closable={false}
                                                showImage={false} />
                                        </div>)
                                }
                                )}
                            </div>
                        </Col>
                    </Row>}
                {
                    !isEmpty(info.senderIdData) && (info.senderIdData?.is_vsms_enabled).toString() !== "0" &&
                    <Row className={Styles.inputField}>
                        <Col size={12}>
                            {/* <Checkbox label={t('BLD01505')} className={Styles.checkbox} checked={applyForSenderIdStatus} onChange={(event: any) => setApplyForSenderIdStatus(event.target.checked)} /> */}
                        </Col>
                    </Row>
                }
                {
                    applyForSenderIdStatus && (info.senderIdData?.is_vsms_enabled).toString() !== "0" &&
                    <Row className={Styles.inputField}>
                        <Col size={12}>
                            <MultiSelectCheckBox placeholder={t('BLD01636')} label={t('BLD01636')}
                                options={getRoutesList()}
                                searchString={t('mainSearch')}
                                onChange={(e: any) => setSelectedvSMSRoutes([...e])}
                                value={selectedvSMSRoutes}
                                direction="bottom"
                            />
                        </Col>
                    </Row>
                }
            </div>
        </form>
    };


    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={() => handleFormSave()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const updateDocumentList = (selectedRecentDocs: Array<UploadDocumentResponseType>) => {
        const uploadList = uploadedFile.concat(selectedRecentDocs);
        setUploadedFile(uploadList);
    }

    return (
        <>
            <Slider
                containerId="root-modal"
                onClose={onClose}
                visibility={true}
                footer={getFooter()}
                title={t('smsEditSenderID')}
            >
                <div className={Styles.container}>{getBody()}</div>
            </Slider>
            {showUploadDocumentList && <UploadedDocuments
                documentList={info.senderIdData.docs || []}
                onClose={() => setShowUploadDocumentList(false)}
                setSelectedDocuments={(selectedDoc: Array<any>) => updateDocumentList(selectedDoc)}
            />}
        </>
    );


}

export default SenderIdEditForm;